export default {
  page_404: 'Sorry, the page you visited does not exist.',
};
